<template>
  <el-card
    class="background"
    v-loading="loading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <div class="contract-overview">
      <!-- @saleDeptChange="(value) => valueChangeHandler('saleDepartment', value)" -->
      <SiruiSearch
        ref="searchRef"
        :query="queryData"
        :columns="topColumns"
        :isQueryPanel="true"
        @resetBtnClick="resetBtnClick"
        @searchBtnClick="searchTrigger"
        @createDeptChange="(value) => valueChangeHandler('createDepartment', value)"
        @chargePersonChange="(value) => valueChangeHandler('chargePerson', value)"
        @serviceChange="(value) => valueChangeHandler('service', value)"
        @contractTypeChange="(value) => valueChangeHandler('contractType', value)"
        @contractStatusChange="(value) => valueChangeHandler('contractStatus', value)"
        @thirdPartyChange="(value) => valueChangeHandler('thirdParty', value)"
        @businessDepartmentChange="(value) => valueChangeHandler('businessDepartment', value)"
        @platformCompanyChange="(value) => valueChangeHandler('platformCompanyCode', value)"
      ></SiruiSearch>
      <div class="result-table">
        <sirui-table
          ref="siruiTable"
          :buttonList="menuButtonList"
          @chooseClick="chooseClick"
          :loading="loading"
          @handleSelectionChange="handleSelectionChange"
          @handleSizeChange="() => getTableData()"
          @handleCurrentChange="() => getTableData()"
          @dblclickEvent="dblclickEvent"
          :data="tableData"
          :paging="true"
          :setting="false"
          :customVisible="false"
          :columns="tableColumns"
        >
          <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
          <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
          <vxe-table-column
            v-for="(item, index) in tableColumns"
            :key="index"
            :fixed="item.fixed"
            :sortable="item.sortable"
            :field="item.field"
            :title="item.title ? $t(item.title) : null"
            :visible="item.visible"
            :type="item.type"
            :width="item.width"
          >
            <template slot-scope="scope">
              <span v-if="item.field == 'contractStatus'">
                {{ getStatusName('contract', scope.row[item.field]) }}</span
              >
              <span
                v-else-if="
                  item.field == 'contractSignDate' ||
                  item.field == 'contractEffectDate' ||
                  item.field == 'contractExpireDate'
                "
              >
                {{ formatDateCustom(scope.row[item.field], false) }}</span
              >
              <span v-else-if="item.field == 'contractType'">
                {{ scope.row[item.field] == '0' ? '常规合同' : '结算条款' }}</span
              >
              <span v-else>{{ scope.row[item.field] }}</span>
            </template>
          </vxe-table-column>
        </sirui-table>
      </div>
      <CommonTextDialog ref="textDialog"></CommonTextDialog>
      <SelectPartnerDialog
        ref="selectPartnerDialogRef"
        @confirm="getPartnerType"
      ></SelectPartnerDialog>
    </div>
  </el-card>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import { searchColumns, defaultTableColumns } from './columns';
  import ContractOverviewMixin from '@/pages/intermodality/otherContract/overview/ContractOverviewMixin';
  import ContractServiceMixin from '@/pages/intermodality/otherContract/detail/mixins/ContractServiceMixin';
  import IntermodalityCommonMixin from '@/pages/intermodality/common/mixins/IntermodalityCommonMixin';
  import CommonTextDialog from '../../common/components/dialogs/CommonTextDialog.vue';
  import SelectPartnerDialog from '../../project/projectOverview/components/SelectPartnerDialog.vue';
  import BASE_API from '@/api/dataBase';

  export default {
    name: 'otherContract',
    mixins: [ContractOverviewMixin, IntermodalityCommonMixin, ContractServiceMixin],
    components: {
      SiruiSearch,
      CommonTextDialog,
      SelectPartnerDialog,
    },
    mounted() {
      this.getCompanyList();
      let name = this.$route.name;
      this.isCustomerContract = name == 'customerContract';
      this.$refs.siruiTable.setPageSize(10);
      // this.queryData = this.getDefaultSearchData();
      // this.getTableData();
      this.getButtonList();
      this.statuList = this.dictListMap.intermodality_contract_statu?.filter(
        (element) => element.value != 'ZT06' && element.value != 'ZT07'
      );
      console.log('this.statuList', this.statuList);
    },
    data() {
      return {
        loading: false,
        isCustomerContract: true,
        tableColumns: [],
        menuButtonList: [], // 表格功能按钮
        selectedItems: [],
        companyList: [],
        departmentList: [],
        statuList: [],
      };
    },
    computed: {
      topColumns() {
        return searchColumns(this);
      },
      getExtraData() {
        let params = { projectStatus: ['xmzt03', 'xmzt05'] };
        if (this.isCustomerContract) {
          params.isConversionContract = '0';
        }
        return params;
      },
    },
    methods: {
      async getCompanyList() {
        const params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          // personCompanyCode: this.userInfo.companyCode,
        };
        const res = await this.$axios.post(BASE_API.GET_PERSON_API, params);
        // console.log(res.data.data.personDepartmentInfo,'personDepartmentInfo');
        this.companyList = res.data.data?.personCompanyInfo.filter((item) => {
          return item.personCompanyCode != 'OAC19';
        });
        console.log(res.data.data.personCompanyInfo, this.companyList);
        if (this.userInfo.companyCode != 'OAC19') {
          this.queryData = {
            ...this.queryData,
            platformCompanyName: this.userInfo.companyName,
            platformCompanyCode: this.userInfo.companyCode,
          };
        }
        if (this.queryData.platformCompanyCode) {
          this.department(this.queryData.platformCompanyCode);
        }
        this.getTableData();
      },
      getPartnerType(partner, query) {
        let partnerCode = query.isUpOrDown == '0' ? partner.upPartnerCode : partner.downPartnerCode;
        // this.convertContract(query.isUpOrDown, query.projectCode, partnerCode);
        // //项目转合同
        let params = {
          projectCode: query.projectCode,
          pageMode: 0,
          origin: 'createFrom',
          partnerCode: partnerCode,
        };
        this.toDetailPage(params);
        // this._convert(
        //   val,
        //   this.selectedItems[0].projectCode
        //   // this.selectedItems[0].isConversionContract
        // );
      },
      resetBtnClick() {
        this.queryData.platformCompanyName = null;
        this.queryData.businessDepartmentName = null;
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        // this.$refs.searchRef.$refs.saleDepartmentName[0].resetClick();
        // this.$refs.searchRef.$refs.createDepartmentName[0].resetClick();
        this.selectedItems = [];
        // this.queryData = this.getDefaultSearchData();
        this.getTableData();
      },
      handleSelectionChange(row) {
        this.selectedItems = row;
        console.log(row);
      },
      // 搜索
      searchTrigger() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getTableData();
      },
      selectProjectHandler(row) {
        let isUpOrDown = this.isCustomerContract ? '0' : '1';
        this.$refs.selectPartnerDialogRef.openModal(row.projectCode, isUpOrDown);
      },

      // 表格上面的按钮
      async chooseClick(type) {
        console.log(this.selectedItems);
        let empty = !this.selectedItems || !this.selectedItems.length;
        let justOne = this.selectedItems.length == 1;
        let contractStatus = justOne ? this.selectedItems[0].contractStatus : '';
        let contractCode = justOne ? this.selectedItems[0].contractCode : '';
        let contractType = justOne ? this.selectedItems[0].contractType : '';
        let statusName = this.getStatusName('contract', contractStatus);

        console.log('listStatus', empty, justOne, statusName);
        console.log('click', type);
        // 复制、启用、停用
        if (['activate', 'deactivate', 'copy'].includes(type)) {
          if (empty || !justOne) {
            this.$message({
              type: 'error',
              message: '请选择一条数据',
            });
            return;
          }
        }

        if (type == 'create') {
          this.toDetailPage({ pageMode: 0, origin: 'create' });
        } else if (type == 'copy') {
          // contractType == '1' 结算条件，0-常规合同
          if (contractType == '1') {
            this.$message({
              type: 'error',
              message: '结算条款不能复制',
            });
            return;
          }
          this.toDetailPage({ pageMode: 0, origin: 'copy', contractCode });
        } else if (type == 'activate') {
          if (statusName != '已停用') {
            this.$message({
              type: 'error',
              message: '请选择一条已停用的数据',
            });
            return;
          }
          this.$confirmAction(`其他合同启用确认`, `是否确定要启用此其他合同?`, '确认启用', '取消')
            .then(async () => {
              await this.handleUpdateStatus(true, contractCode, contractType, false);
            })
            .catch(() => {
              this.loading = false;
              this.$message({
                type: 'info',
                message: '已取消',
              });
            });
        } else if (type == 'deactivate') {
          if (statusName != '已生效') {
            this.$message({
              type: 'error',
              message: '请选择一条已生效的数据',
            });
            return;
          }
          this.$confirmAction('其他合同停用确认', '是否确定要停用此合同？', '确认停用', '取消')
            .then(async () => {
              await this.handleUpdateStatus(false, contractCode, contractType, false);
            })
            .catch((e) => {
              console.log(e);
              this.loading = false;
              this.$message({
                type: 'info',
                message: '已取消',
              });
            });
        }
        // 结算条款
        // else if (type == 'supplement') {
        //   if (statusName != '已生效') {
        //     this.$message({
        //       type: 'error',
        //       message: '请选择一条已生效的数据',
        //     });
        //     return;
        //   }
        //   if (contractType != '0') {
        //     this.$message({
        //       type: 'error',
        //       message:
        //         '新增失败！您选择的合同已为结算条款，不可再新增结算条款，请选择结算条款所属的常规合同进行结算条款维护',
        //     });
        //     return;
        //   }
        //   this.toDetailPage({ pageMode: 0, origin: 'supplement', contractCode });
        // }
      },
      dblclickEvent({ row }) {
        console.log('detail', row);
        let params = { contractCode: row.contractCode, pageMode: 1, origin: 'detail' };
        this.toDetailPage(params);
      },
      //获取当前列数据
      getColumnInfo() {
        this.getColumnList(defaultTableColumns(this.isCustomerContract)).then(() => {
          this.tableColumns = defaultTableColumns(this.isCustomerContract);
        });
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          console.log('menuButtons', this.menuButtonList);
          this.getColumnInfo();
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
